import { render, staticRenderFns } from "./datatableStoricoPagamenti.vue?vue&type=template&id=a72c560a"
import script from "./datatableStoricoPagamenti.vue?vue&type=script&lang=js"
export * from "./datatableStoricoPagamenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports